import * as actions from "../actionTypes"

const initialState = {
    value: false,
}

export default function actionsIndicator(state = initialState, action) {
    switch (action.type) {
        case actions.SET_HAS_ACTIONS: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
